/**
 * winston/console 风格 variadic 元数据合并工具（server-logger / edge-logger 共用）
 */

/**
 * Error 实例规范化：转成普通对象后由 JSON 序列化转义换行，
 * 保证输出物理上仍为单行（SLS 按行采集时一条日志一条记录）
 */
export function serializeError(err: Error): Record<string, unknown> {
    return {
        name: err.name,
        message: err.message,
        stack: err.stack,
    };
}

/**
 * 将 variadic 元数据参数 (msg, meta1, meta2, ...)
 * 合并为 pino 的单个数据对象；Error 实例放到 err / error 键下
 */
export function mergeMeta(meta: any[]): Record<string, any> {
    const obj: Record<string, any> = {};
    const primitives: unknown[] = [];

    for (const item of meta) {
        if (item === undefined || item === null) continue;

        if (item instanceof Error) {
            if (!('err' in obj)) {
                obj.err = serializeError(item);
            } else if (!('error' in obj)) {
                obj.error = serializeError(item);
            }
            continue;
        }

        if (typeof item === 'object' && !Array.isArray(item)) {
            Object.assign(obj, item);
        } else {
            primitives.push(item);
        }
    }

    if (primitives.length === 1) {
        obj.value = primitives[0];
    } else if (primitives.length > 1) {
        obj.values = primitives;
    }

    return obj;
}
